import type { BoardDefinition, BoardRegistryManifest } from '@skyrover/shared/types';

import arduinoMega from '../boards/arduino-mega-2560/board.json';
import arduinoNano from '../boards/arduino-nano/board.json';
import arduinoUno from '../boards/arduino-uno/board.json';
import esp32Devkit from '../boards/esp32-devkit/board.json';
import esp8266Nodemcu from '../boards/esp8266-nodemcu/board.json';
import skyroverEsp32S3 from '../boards/skyrover-esp32-s3/board.json';
import manifest from '../manifest.json';

const registry = manifest as BoardRegistryManifest;

const boardFiles: Record<string, BoardDefinition> = {
  'arduino-uno': arduinoUno as unknown as BoardDefinition,
  'arduino-nano': arduinoNano as unknown as BoardDefinition,
  'arduino-mega-2560': arduinoMega as unknown as BoardDefinition,
  'esp8266-nodemcu': esp8266Nodemcu as unknown as BoardDefinition,
  'esp32-devkit': esp32Devkit as unknown as BoardDefinition,
  'skyrover-esp32-s3': skyroverEsp32S3 as unknown as BoardDefinition,
};

/** All enabled board definitions keyed by ID */
export const boards: Record<string, BoardDefinition> = Object.fromEntries(
  registry.boards
    .filter((entry) => entry.enabled !== false)
    .map((entry) => [entry.id, boardFiles[entry.id]!]),
);

/** Ordered list of board IDs for UI dropdowns */
export const boardIds: string[] = registry.boards
  .filter((entry) => entry.enabled !== false)
  .map((entry) => entry.id);

export function getBoard(id: string): BoardDefinition | undefined {
  return boards[id];
}

export function getAllBoards(): BoardDefinition[] {
  return boardIds.map((id) => boards[id]!);
}

export { manifest as boardRegistryManifest };
